import {z} from 'zod';

import {WarrantyTypeCodeSchema, WarrantyTypeSourceSchema} from '@dms/api/sales';
import i18n from '@dms/i18n';

export const WarrantyTypeFormSchema = z.object({
  warrantyType: WarrantyTypeCodeSchema,
  source: WarrantyTypeSourceSchema,
  durationMonths: z.number().nullable(),
  durationKm: z.number().nullable(),
  description: z
    .string({required_error: i18n.t('general.validations.fieldIsRequired')})
    .trim()
    .min(1, i18n.t('general.validations.fieldIsRequired')),
  externalId: z.string().nullable(),
});

export type WarrantyTypeFormType = z.infer<typeof WarrantyTypeFormSchema>;
